import React, { forwardRef } from "react"
import {
  Button
} from "@material-ui/core"

export const NavItem = forwardRef((props, ref) => {
  const { icon, active, style, children, ...rest } = props
  //if (!icon && !rest.onClick && children) return children
  return (
    <Button
      ref={ref}
      {...(active && { variant: "contained", color: "primary" })}
      style={{
        ...style,
        aspectRatio: icon && "1 / 1",
        paddingLeft: 12,
        paddingRight: 12,
        height: 36,
        flexShrink: 0
      }}
      {...rest}
    >
      <span style={{ flexGrow: 1, textAlign: "left", display: "flex" }}>
        {!icon && children}
        {icon}
      </span>
    </Button>
  )
})